export const deleteRegularization = `
 mutation DeleteRegularizationApproval($id: ID!) { 
  
    deleteRegularizationApproval(id: $id) { 
  
      regularizationApproval { 
  
        id 
  
        checkIn 
  
        checkOut 
  
        reason 
  
        teamleaderId 
  
      } 
  
      message 
  
      success 
  
      error 
  
    } 
  
  } 
`;

export const submitRegularizationMutation = `
    mutation regularizationRequest($input: RegularizationApprovalInput!){  
    regularizationApproval(input: $input){  
      regularizationApproval{  
        id 
        checkIn 
        checkOut 
        reason 
        requestedDate 
        user{ 
          id 
          email 
        } 
        teamleaderId 
        status 
        teamApproval 
        hrApproval 
      }  
    message 
    success 
    error 
    } 
  }  `

